import { endPoints, requestType } from "../theme/Variables";
import Api from "./index";

export const fetchDashboard = () => {
  return Api(endPoints.dashboardData, null, requestType.GET);
};
